<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	let { config }: { config: BrandConfig } = $props();

	// Default values for Artificer Innovations, LLC
	const defaultCompanyName = 'Artificer Innovations, LLC';
	const defaultEmail = 'contact@artificerinnovations.com';
	const defaultPhone = '+1-425-522-3038';
	const defaultMailingAddress = 'Artificer Innovations LLC, 522 W Riverside AVE STE N, Spokane, WA 99201 United States';

	// Use brand-specific values if provided, otherwise fall back to defaults
	const companyName = config.legalContact?.companyName ?? defaultCompanyName;
	const email = config.legalContact?.email ?? defaultEmail;
	const phone = config.legalContact?.phone ?? defaultPhone;
	const mailingAddress = config.legalContact?.mailingAddress ?? defaultMailingAddress;
</script>

<div class="legal-contact">
	<p><strong>{companyName}</strong></p>
	<ul>
		<li><strong>Email</strong>: <a href="mailto:{email}">{email}</a></li>
		<li><strong>Phone</strong>: <a href="tel:{phone}">{phone}</a></li>
		<li><strong>Mailing Address</strong>: {mailingAddress}</li>
	</ul>
</div>

<style>
	.legal-contact {
		background: #f8fafc;
		border: 1px solid #e2e8f0;
		border-radius: 8px;
		padding: 1.5rem;
		margin: 2rem 0;
	}


	.legal-contact p {
		margin-bottom: 0.75rem;
		color: #374151;
		line-height: 1.6;
	}

	.legal-contact ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.legal-contact li {
		margin-bottom: 0.5rem;
		color: #374151;
		line-height: 1.6;
	}

	.legal-contact a {
		color: var(--brand-primary);
		text-decoration: none;
		font-weight: 500;
	}

	.legal-contact a:hover {
		text-decoration: underline;
	}

	.legal-contact strong {
		color: var(--brand-primary);
		font-weight: 600;
	}
</style>
